/** The invite forms (Team & roles, and Add teammate on a domain) share one draft: who is being invited, and as what. */
export const INVITE_DRAFT_KEY = "team.invite";

export interface InviteDraft {
  first: string;
  last: string;
  email: string;
  roleId: string;
}
